module.exports = __webpack_public_path__ + "static/media/toggle-up.cc6c571c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/megabus/toggle-up.svg
// module id = 756
// module chunks = 0